<template>
  <div style="height: 100%; position: relative" class="mapDiv">
    <map-nav-bar :btmList="btmList" class="cyzl-nav-bar" />
    <div id="map" class="map"></div>
    <c-detail
      v-if="JSON.stringify(poisiton) !== '{}'"
      :form="poisiton"
      class="detail"
    ></c-detail>
  </div>
</template>

<script>
import * as L from "leaflet";
import "proj4";
import "proj4leaflet";
const esri = require("esri-leaflet");
import "leaflet/dist/leaflet.css";
import cDetail from "../util/detail";
import changeMap from "../util/changeMap";
import { getMMLZDPZHWL, findOrgCompanyByType } from "@/api/map";
import { mapGetters } from "vuex";
import { findIndexByName } from "@/util/index";
export default {
  components: {
    cDetail,
  },
  computed: {
    ...mapGetters(["layerComponent"]),
  },
  watch: {
    layerComponent(val) {
      this.pointChoose(val);
    },
  },
  data() {
    return {
      rightPath: "rightDrawer",
      type: "",
      map: null,
      daiArr: [],
      jdArr: [],
      kjArr: [],
      zhwlArr: [],
      ydArr: [],
      hoverList: [],
      ncIndex: null,
      ncCode: "",
      poisiton: {},
      pointList: [],
      baseList: [],
      baseList2: [],
      zhwlList: [],
      hoverArr: [],
      beltObj: {},
      areaList: [],
      pointAnchor: [20, 50],
      baseAnchor: [10, 50],
      djd: [10, 50],
      ydAnchor: [10, 40],
      ydtAnchor: [10, 40],
      ydwAnchor: [10, 55],
      mianArr: [],
      btmList: [
        {
          name: "红色区域为茂名市荔枝优势产区产业园（荔枝种植面积40万亩）",
          pic: require("images/map/red.jpg"),
        },
        {
          name: "粉色区域为茂名荔枝主产区（面积超过10000亩以上镇街）",
          pic: require("images/map/fs.jpg"),
        },
        {
          name: "浅粉色区域为茂名荔枝产区（面积超过1000亩以上镇街）",
          pic: require("images/map/dfs.jpg"),
        },
        {
          name: "黄星区域为茂名市荔枝国家现代农业产业园核心区",
          pic: require("images/map/yelxx.png"),
        },
        {
          name: "蓝星区域为茂名市荔枝优势产区产业园核心区",
          pic: require("images/map/bluexx.png"),
        },
        {
          name: "国家荔枝种质资源圃、中国荔枝博览馆",
          pic: require("images/index/map/jd.png"),
        },
        {
          name: "贡园和古荔园",
          pic: require("images/map/gy2.png"),
        },
      ],
      // btmList: [
      //   {
      //     name: "面积>40万亩",
      //     pic: require("images/map/red.jpg")
      //   },
      //   {
      //     name: "面积>1万亩",
      //     pic: require("images/map/fs.jpg")
      //   },
      //   {
      //     name: "面积>1000亩",
      //     pic: require("images/map/dfs.jpg")
      //   },
      //   {
      //     name: "茂名荔枝国家现代农业产业园(面积39.6万亩)",
      //     pic: require("images/map/yelxx.png")
      //   },
      //   {
      //     name: "茂名荔枝国家现代农业产业园",
      //     pic: require("images/map/bluexx.png")
      //   },
      //   {
      //     name: "贡园",
      //     pic: require("images/map/gy2.png")
      //   }
      // ]
    };
  },
  mounted() {
    this.initMap();
  },
  methods: {
    changeMap(url) {
      // 修改切片图层
      this.removemap2();
      if (url) {
        this.tileMapLayer2 = esri.tiledMapLayer({
          url: url,
        });
        window.map.addLayer(this.tileMapLayer2);
      }
    },
    removemap2() {
      // 删除切片图层
      if (this.tileMapLayer2) {
        this.tileMapLayer2._container.remove();
        this.tileMapLayer2.remove();
        this.tileMapLayer2 = null;
      }
    },
    initMap() {
      // 加载底图
      let tileMapUrl = this.$config.tileMapUrl;
      let CRS_4490 = new L.Proj.CRS(
        "EPSG:4490",
        "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs",
        {
          resolutions: this.$config.resolutions,
          origin: [-400.0, 399.9999999999998],
        }
      );

      this.map = L.map("map", {
        crs: CRS_4490,
        minZoom: this.$config.sZoom,
        maxZoom: this.$config.mZoom,
        zoomControl: false,
      });

      window.map = this.map;

      let tileMapLayer = esri.tiledMapLayer({
        url: tileMapUrl,
      });
      tileMapLayer.addTo(this.map);
      this.map.setView(L.latLng(this.$config.sLat, this.$config.sLng), 0);
      this.changeMap(
        window.__config.VUE_APP_MAP_URL +
          "/rest/services/440900/mm_lz_02/MapServer"
      );
      //   L.marker([21.90721536507698, 110.97675883177209]).addTo(this.map); // 对比divicon
      this.dataLoad();
      this.nowZoom = this.map.getZoom();
      this.map.on("click", (e) => {
        console.log(e.latlng);
      });
      // this.beltLoad();
      // this.baseLoad();
      // this.areaLoad1();
      // this.pointLoad();
    },
    //加载标记点数据
    dataLoad() {
      let data = {
        code: 200,
        data: [
          {
            img: "zxd.png",
            code: "0201",
            tc_request_url: "1",
            latitude: "21.79034283273087",
            tc_color: null,
            tc_pic: "zxd",
            tc_name: "世界荔乡科创中心",
            type: "point",
            tc_template: "companyDrawer",
            tc_status: 2,
            grade: 3,
            tc_leftRight: "right",
            name: "世界荔乡科创中心",
            tc_type: "point",
            tc_id: "79ac212440584f5fb2d1e2f166a5afdb",
            tc_quote_template: "companyDrawer",
            config: null,
            desc:
              '<p><span style="font-family: 宋体, SimSun; color: rgb(255, 255, 255); font-size: 12px;">位于根子镇。充分利用根子镇作为省级荔枝专业创新示范镇的政策平台优势及茂名市荔枝国家现代农业产业园及高州市荔枝省级现代农业产业园的建设发展基础，依托国家荔枝种质资源圃、中国荔枝博览馆等，切实增强园区的集聚力、辐射力和带动力，围绕荔枝全产业链对科创发展的需求，成立中国荔枝产业研究院，共同搭建现代荔枝产业科技创新中心，全面开展产业技术创新升级和示范推广，成为产业持续发展驱动核，全面推进产业提档升级。引导以茂名荔枝为主导的特色农产品展示、商贸、仓储、加工等集聚发展，不断壮大产业集群规模，着力拓展荔枝加工业、电商物流业、生态旅游业等发展空间，拉长产业链条，推动产业深度融合。</span></p>',
            longitude: "111.09557186239743",
          },

          //   {
          //     area: 211,
          //     code: "0302",
          //     config: null,
          //     desc:
          //       '<p><span style="font-family: 宋体, SimSun; color: rgb(255, 255, 255); font-size: 12px;">位于根子镇、分界镇。依托根子镇省级荔枝专业创新示范镇和分界镇世华工业区平台，利用当地荔枝初加工深厚产业基础、企业集聚和技术积累优势，引进高效适用的荔枝初加工工艺和设备，推进荔枝初加工产业标准化、现代化、高质量发展。</span></p>',
          //     grade: 3,
          //     img: "ico_line",
          //     latitude: "21.63714654091524",
          //     longitude: "111.0872847954929",
          //     name: "国家荔枝种质资源圃",
          //     tc_color: null,
          //     tc_id: "c70e3ca4473d4d73b03566515889d84d",
          //     tc_leftRight: "right",
          //     tc_name: "三区：荔枝标准化初加工集聚区",
          //     tc_pic: "jd.png",
          //     tc_quote_template: "companyDrawer",
          //     tc_request_url: "",
          //     tc_status: 1,
          //     tc_template: "companyDrawer",
          //     tc_type: "point",
          //     type: "polygon"
          //   },
          {
            area: 211,
            code: "0302",
            config: null,
            desc:
              '<p><span style="font-family: 宋体, SimSun; color: rgb(255, 255, 255); font-size: 12px;">位于水东街道。借助电白省级农产品加工示范园平台，通过招商引资、改造重组、联营联合等形式，培育壮大一批联结荔枝生产基地的加工型龙头企业，鼓励和支持科研机构、高等院校和荔枝生产经营主体依托园区优势条件，联合建立科技创新与成果转化机制，着力荔枝精深加工产品的研发、生产、创新，推进荔枝产业链延伸和价值链提升。</span></p>',
            grade: 3,
            img: "ico_line",
            latitude: "21.80275702692103",
            longitude: "111.0396955753763",
            name: "国家荔枝种质资源圃",
            tc_color: null,
            tc_id: "c70e3ca4473d4d73b03566515889d84d",
            tc_leftRight: "left",
            tc_name: "三区：荔枝精深加工创新发展区",
            tc_pic: "jd.png",
            tc_quote_template: "companyDrawer",
            tc_request_url: "",
            tc_status: 1,
            tc_template: "companyDrawer",
            tc_type: "point",
            type: "polygon",
          },
          {
            area: 300,
            code: "0604",
            config: null,
            desc: "茂名荔枝国家现代农业产业园(荔枝面积39.6万亩)",
            grade: 3,
            img: "yelxx",
            latitude: "21.90721536507698",
            longitude: "110.97675883177209",
            name: "茂名荔枝国家现代农业产业园",
            tc_color: "#f3e80c",
            tc_id: "ca1a3c8c2aa943fa88236f091794aa8f",
            tc_leftRight: "1",
            tc_name: "多基地",
            tc_pic: "ico_sf",
            tc_quote_template: "companyDrawer",
            tc_request_url: "",
            tc_status: 1,
            tc_template: "companyDrawer",
            tc_type: "point",
            type: "point",
          },
          {
            area: 300,
            code: "0604",
            config: null,
            desc: "茂名荔枝国家现代农业产业园(荔枝面积39.6万亩)",
            grade: 3,
            img: "yelxx",
            latitude: "21.839995591662273",
            longitude: "110.97318964026334",
            name: "泗水镇",
            tc_color: "#f3e80c",
            tc_id: "ca1a3c8c2aa943fa88236f091794aa8f",
            tc_leftRight: "1",
            tc_name: "多基地",
            tc_pic: "ico_sf",
            tc_quote_template: "companyDrawer",
            tc_request_url: "",
            tc_status: 1,
            tc_template: "companyDrawer",
            tc_type: "point",
            type: "point",
          },
          {
            area: 300,
            code: "0604",
            config: null,
            desc: "茂名荔枝国家现代农业产业园(荔枝面积39.6万亩)",
            grade: 3,
            img: "yelxx",
            latitude: "21.778129605510685",
            longitude: "110.95117962595943",
            name: "分界镇",
            tc_color: "#f3e80c",
            tc_id: "ca1a3c8c2aa943fa88236f091794aa8f",
            tc_leftRight: "1",
            tc_name: "多基地",
            tc_pic: "ico_sf",
            tc_quote_template: "companyDrawer",
            tc_request_url: "",
            tc_status: 1,
            tc_template: "companyDrawer",
            tc_type: "point",
            type: "point",
          },
          {
            area: 300,
            code: "0604",
            config: null,
            desc: "茂名荔枝国家现代农业产业园(荔枝面积39.6万亩)",
            grade: 3,
            img: "yelxx",
            latitude: "21.815011251101055",
            longitude: "110.87206254751555",
            name: "金山街道",
            tc_color: "#f3e80c",
            tc_id: "ca1a3c8c2aa943fa88236f091794aa8f",
            tc_leftRight: "1",
            tc_name: "多基地",
            tc_pic: "ico_sf",
            tc_quote_template: "companyDrawer",
            tc_request_url: "",
            tc_status: 1,
            tc_template: "companyDrawer",
            tc_type: "point",
            type: "point",
          },
          {
            area: 300,
            code: "0604",
            config: null,
            desc: "茂名荔枝国家现代农业产业园(荔枝面积39.6万亩)",
            grade: 3,
            img: "yelxx",
            latitude: "21.734109576902824",
            longitude: "110.9303593421584",
            name: "山阁镇",
            tc_color: "#f3e80c",
            tc_id: "ca1a3c8c2aa943fa88236f091794aa8f",
            tc_leftRight: "1",
            tc_name: "多基地",
            tc_pic: "ico_sf",
            tc_quote_template: "companyDrawer",
            tc_request_url: "",
            tc_status: 1,
            tc_template: "companyDrawer",
            tc_type: "point",
            type: "point",
          },
          {
            area: 300,
            code: "0604",
            config: null,
            desc: "茂名荔枝国家现代农业产业园(荔枝面积39.6万亩)",
            grade: 3,
            img: "yelxx",
            latitude: "21.705556044832864",
            longitude: " 110.97497423601772",
            name: "羊角镇",
            tc_color: "#f3e80c",
            tc_id: "ca1a3c8c2aa943fa88236f091794aa8f",
            tc_leftRight: "1",
            tc_name: "多基地",
            tc_pic: "ico_sf",
            tc_quote_template: "companyDrawer",
            tc_request_url: "",
            tc_status: 1,
            tc_template: "companyDrawer",
            tc_type: "point",
            type: "point",
          },
          {
            area: 300,
            code: "0604",
            config: null,
            desc: "茂名荔枝国家现代农业产业园(荔枝面积39.6万亩)",
            grade: 3,
            img: "yelxx",
            latitude: "21.624059505383173",
            longitude: "110.98627667579541",
            name: "坡心镇",
            tc_color: "#f3e80c",
            tc_id: "ca1a3c8c2aa943fa88236f091794aa8f",
            tc_leftRight: "1",
            tc_name: "多基地",
            tc_pic: "ico_sf",
            tc_quote_template: "companyDrawer",
            tc_request_url: "",
            tc_status: 1,
            tc_template: "companyDrawer",
            tc_type: "point",
            type: "point",
          },
          {
            area: 300,
            code: "0604",
            config: null,
            desc: "茂名荔枝国家现代农业产业园(荔枝面积39.6万亩)",
            grade: 3,
            img: "yelxx",
            latitude: "21.797760158808785",
            longitude: "111.04873752719845",
            name: "根子镇",
            tc_color: "#f3e80c",
            tc_id: "ca1a3c8c2aa943fa88236f091794aa8f",
            tc_leftRight: "1",
            tc_name: "多基地",
            tc_pic: "ico_sf",
            tc_quote_template: "companyDrawer",
            tc_request_url: "",
            tc_status: 1,
            tc_template: "companyDrawer",
            tc_type: "point",
            type: "point",
          },
          {
            area: 300,
            code: "0604",
            config: null,
            desc: "茂名荔枝国家现代农业产业园(荔枝面积39.6万亩)",
            grade: 3,
            img: "yelxx",
            latitude: "21.75165810182085",
            longitude: "111.08294227915724",
            name: "霞洞镇",
            tc_color: "#f3e80c",
            tc_id: "ca1a3c8c2aa943fa88236f091794aa8f",
            tc_leftRight: "1",
            tc_name: "多基地",
            tc_pic: "ico_sf",
            tc_quote_template: "companyDrawer",
            tc_request_url: "",
            tc_status: 1,
            tc_template: "companyDrawer",
            tc_type: "point",
            type: "point",
          },
          {
            area: 300,
            code: "0604",
            config: null,
            desc: "茂名荔枝国家现代农业产业园(荔枝面积39.6万亩)",
            grade: 3,
            img: "yelxx",
            latitude: "21.642500328178357",
            longitude: "111.08264484653155",
            name: "林头镇",
            tc_color: "#f3e80c",
            tc_id: "ca1a3c8c2aa943fa88236f091794aa8f",
            tc_leftRight: "1",
            tc_name: "多基地",
            tc_pic: "ico_sf",
            tc_quote_template: "companyDrawer",
            tc_request_url: "",
            tc_status: 1,
            tc_template: "companyDrawer",
            tc_type: "point",
            type: "point",
          },
          {
            area: 300,
            code: "0604",
            config: null,
            desc: "茂名荔枝国家现代农业产业园(荔枝面积39.6万亩)",
            grade: 3,
            img: "yelxx",
            latitude: "21.53363998716162",
            longitude: "111.10227539982964",
            name: "旦场镇",
            tc_color: "#f3e80c",
            tc_id: "ca1a3c8c2aa943fa88236f091794aa8f",
            tc_leftRight: "1",
            tc_name: "多基地",
            tc_pic: "ico_sf",
            tc_quote_template: "companyDrawer",
            tc_request_url: "",
            tc_status: 1,
            tc_template: "companyDrawer",
            tc_type: "point",
            type: "point",
          },
          {
            area: 300,
            code: "0604",
            config: null,
            desc: "茂名荔枝国家现代农业产业园",
            grade: 3,
            img: "bluexx",
            latitude: "21.544848595557824",
            longitude: "111.01483020786537",
            name: "水东镇",
            tc_color: "#f3e80c",
            tc_id: "ca1a3c8c2aa943fa88236f091794aa8f",
            tc_leftRight: "1",
            tc_name: "基地2",
            tc_pic: "ico_sf",
            tc_quote_template: "companyDrawer",
            tc_request_url: "",
            tc_status: 1,
            tc_template: "companyDrawer",
            tc_type: "point",
            type: "point",
          },
          {
            area: 300,
            code: "0604",
            config: null,
            desc: "茂名荔枝国家现代农业产业园",
            grade: 3,
            img: "bluexx",
            latitude: "21.539346991734817",
            longitude: "110.9583180089769",
            name: "七径镇",
            tc_color: "#f3e80c",
            tc_id: "ca1a3c8c2aa943fa88236f091794aa8f",
            tc_leftRight: "1",
            tc_name: "基地2",
            tc_pic: "ico_sf",
            tc_quote_template: "companyDrawer",
            tc_request_url: "",
            tc_status: 1,
            tc_template: "companyDrawer",
            tc_type: "point",
            type: "point",
          },
        ],
      };

      data.data.map((ele) => {
        if (ele.img === "zxd.png") {
          this.pointList.push(ele);
        } else if (ele.tc_name.indexOf("多基地") > -1) {
          this.baseList.push(ele);
          this.baseList2.push(ele);
        } else if (ele.tc_name.indexOf("基地2") > -1) {
          this.baseList2.push(ele);
        } else {
          this.areaList.push(ele);
        }
      });
      //   this.getMMLZDPZHWL();
      //   this.pointLoad();
      this.areaLoad1();
      // this.areaLoad();
      this.baseLoad();
      this.baseLoad2();
      //   this.beltLoad();
    },

    //智慧物联点列表
    getMMLZDPZHWL() {
      getMMLZDPZHWL().then((res) => {
        if (res.code == 200) {
          this.zhwlList = res.data;
        }
      });
    },
    //两区数据加载
    areaLoad1() {
      if (this.areaLayer) {
        this.map.removeLayer(this.areaLayer);
      }
      this.areaLayer = new L.layerGroup();
      if (this.areaList.length > 0) {
        for (let i = 0, len = this.areaList.length; i < len; i++) {
          // let lineUrl = require("images/index/map/line_map.png");
          let pointUrl = require("images/index/map/" + this.areaList[i].tc_pic);
          this.$set(this.areaList[i], "lat", this.areaList[i].latitude);
          this.$set(this.areaList[i], "lng", this.areaList[i].longitude);
          let myIcons = L.divIcon({
            html:
              "<div class='indicator-box'><div style='display:flex'><img src='" +
              pointUrl +
              "' /></div></div>",
            className: "ztgh-div-icon",
            iconAnchor: [13, 27],
          });
          // let myIcons = L.divIcon({
          //   html:
          //     "<div class='indicator-box'><div style='display:flex'><img src='" +
          //     pointUrl +
          //     "' /></div><div class='ztgh1-div-" +
          //     this.areaList[i].tc_leftRight +
          //     "'><img class='Img" +
          //     this.areaList[i].tc_leftRight +
          //     "' src='" +
          //     lineUrl +
          //     "'/><span class='ztgh-div-names'>" +
          //     this.areaList[i].name +
          //     "</span ></div></div>",
          //   className: "ztgh-div-icon",
          //   iconAnchor: [13, 27]
          // });
          let areaPointLayer = L.marker(
            [this.areaList[i].lat, this.areaList[i].lng],
            {
              icon: myIcons,
              attributes: this.areaList[i],
            }
          ).addTo(this.areaLayer);
          areaPointLayer.on("click", (e) => {
            const data = e.sourceTarget.options.attributes;
            if (data.name === "国家荔枝种质资源圃") {
              findOrgCompanyByType({ type: 8 }).then((res) => {
                if (res.data instanceof Array) {
                  if (res.data.length > 0) {
                    // 缓存rightcomponent
                    sessionStorage.setItem("rightComponent", this.rightPath);
                    this.$store.dispatch("drawer/setGraphic", res.data[0]);
                    this.$store.dispatch(
                      "drawer/setRightComponent",
                      "zypDrawer"
                    );
                  }
                }
              });
            } else {
              // 普通
              sessionStorage.setItem("rightComponent", this.rightPath);
              this.$store.dispatch("drawer/setGraphic", data);
              this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
            }
          });
        }
        this.map.addLayer(this.areaLayer);

        // 贡园
        findOrgCompanyByType({ type: 9 }).then((res) => {
          console.log("res===>", res);
          let zhuArr = res.data;
          let pointUrl = require("images/map/gy2.png");
          // 解析图片
          let jxarr = [
            {
              name: "根子柏桥贡园",
              fximg: require("images/map/gy/右上.png"),
              className: "right-top",
            },
            {
              name: "霞洞上河古荔园",
              fximg: require("images/map/gy/右下.png"),
              className: "right-btm",
            },
            {
              name: "泗水滩底古荔园",
              fximg: require("images/map/gy/左上.png"),
              className: "left-top",
            },
            {
              name: "羊角禄段古荔园",
              fximg: require("images/map/gy/左下.png"),
              className: "left-btm",
            },
          ];
          for (let k = 0, len = zhuArr.length; k < len; k++) {
            var myIcons = "";
            let index = findIndexByName(zhuArr[k].name, jxarr);
            console.log(" index ===", index);
            if (index === -1) {
              continue;
            }
            // const _data = Object.assign(jxarr[index], zhuArr[k]);

            //划过出现名字
            myIcons = L.divIcon({
              html:
                "<div class='indicator-box'><div class='zhu-div-box'><img class='zhu-div-image' src='" +
                pointUrl +
                "'/><div class='zhu-div-text zhu-div-name zhu-yellow' ><span class='zhus-div-name hide yellow'>" +
                zhuArr[k].name +
                "</span></div></div></div>",
              className: "zhu-div-icon",
              iconAnchor: [6, 52],
            });

            //只有标注点
            // myIcons = L.divIcon({
            //   html: [
            //     "<div class='indicator-box'><div class='zhu-div-box'><img class='zhu-div-image' src='",
            //     pointUrl,
            //     "'/></div></div>"
            //   ].join(""),
            //   className: "zhu-div-icon",
            //   iconAnchor: [6, 52]
            // });

            //带箭头图片
            // myIcons = L.divIcon({
            //   html: [
            //     "<div class='indicator-box'><div class='zhu-div-box'><img class='zhu-div-image' src='",
            //     pointUrl,
            //     "'/><img class='nopx-",
            //     _data.className,
            //     "' src='",
            //     _data.fximg,
            //     "'/><div class='nopx-" + _data.className + "-box'>",
            //     "<img class='nopx-pic1' src='",
            //     require("images/map/gy/" + _data.name + "1.png"),
            //     "'/>",
            //     "<img src='",
            //     require("images/map/gy/" + _data.name + ".png"),
            //     "'/>",
            //     "</div></div></div>"
            //   ].join(""),
            //   className: "zhu-div-icon",
            //   iconAnchor: [6, 52]
            // });

            let dPoints = L.marker([zhuArr[k].latitude, zhuArr[k].longitude], {
              interactive: true,
              icon: myIcons,
              attributes: zhuArr[k],
            }).addTo(this.map);

            dPoints.on("click", (e) => {
              const data = e.sourceTarget.options.attributes;
              sessionStorage.setItem("rightComponent", this.rightPath);
              this.$store.dispatch("drawer/setGraphic", data);
              this.$store.dispatch("drawer/setRightComponent", "zypDrawer");
            });
            dPoints.on("mouseover", (it) => {
              it.sourceTarget
                .getElement()
                .querySelector(".zhus-div-name")
                .classList.remove("hide");
            });
            dPoints.on("mouseout", (it) => {
              it.sourceTarget
                .getElement()
                .querySelector(".zhus-div-name")
                .classList.add("hide");
            });
          }
        });
      }
    },
    //两区数据加载
    areaLoad() {
      let areaArr = this.$config.areaArr;
      this.mianArr = [];
      for (let i = 0, len = areaArr.length; i < len; i++) {
        L.polygon(areaArr[i].rings, {
          color: areaArr[i].color,
          fillColor: areaArr[i].color,
          fillOpacity: 0.5,
          attributes: this.areaList[i],
        }).addTo(this.map);
      }
      this.areaLoad1();
    },
    //科技中心数据加载
    pointLoad() {
      this.kjArr = [];
      this.pointList.map((it) => {
        if (this.pointLayer) {
          this.map.removeLayer(this.pointLayer);
        }
        if (it.latitude) {
          let aPoint = new changeMap(it.latitude, it.longitude);
          it.lat = aPoint.lat;
          it.lng = aPoint.lng;
          let lineUrl = require("images/index/map/line_map.png");
          let pointUrl = require("images/index/map/" + it.tc_pic + ".png");
          let pointIcon = L.divIcon({
            html:
              "<div class='indicator-box'><div style='display:flex'><img style='width:50px' src='" +
              pointUrl +
              "' /></div><div class='zxd-div-" +
              it.tc_leftRight +
              "'><img class='Img" +
              it.tc_leftRight +
              "' src='" +
              lineUrl +
              "'/><span class='ztgh-div-names'>" +
              it.name +
              "</span ></div></div>",
            className: "ztgh-div-icon",
            iconAnchor: this.pointAnchor,
          });

          this.pointLayer = L.marker([it.lat, it.lng], {
            icon: pointIcon,
            attributes: it,
          }).addTo(this.map);
          this.kjArr.push(this.pointLayer);
          this.pointLayer.on("click", (e) => {
            sessionStorage.setItem("rightComponent", this.rightPath);
            this.$store.dispatch(
              "drawer/setGraphic",
              e.sourceTarget.options.attributes
            );
            this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
          });
        }
      });
    },

    //多基地数据加载 == 黄星点
    baseLoad() {
      this.jdArr = [];
      if (this.basesGroup) {
        this.map.removeLayer(this.basesGroup);
      }
      this.basesGroup = new L.layerGroup();
      this.baseList.map((it) => {
        if (it.latitude) {
          //   let aPoint = new changeMap(it.latitude, it.longitude);
          //   it.lat = aPoint.lat;
          //   it.lng = aPoint.lng;
          let pointUrl = require("images/map/" + it.img + ".png");
          //   let lineUrl = require("images/index/map/line_map.png");
          var myIcons;
          //   if (it.tc_pic === "ico_sf") {
          myIcons = L.divIcon({
            html:
              "<div class='indicator-box sLine ico_sf'><div class='ztgh-div-box'><img class='ztgh-div-image " +
              it.tc_pic +
              "' src='" +
              pointUrl +
              "'/><div class='zhu-div-text zhu-div-name zhu-yellow' ><span class='zhus-div-name hide yellow'>" +
              "茂名市荔枝国家现代农业产业园核心区" +
              "</span></div>" +
              "</div></div>",
            className: "ztgh-div-icon",
            iconAnchor: [16, 8],
          });
          //   }
          //    else {
          //     myIcons = L.divIcon({
          //       html:
          //         "<div class='indicator-box ico_sf'><div style='display:flex'><img src='" +
          //         pointUrl +
          //         "' /></div><div class='ztgh-div-" +
          //         it.tc_leftRight +
          //         "'><img class='Img" +
          //         it.tc_leftRight +
          //         "' src='" +
          //         lineUrl +
          //         "'/><span class='ztgh-div-names'>" +
          //         it.name +
          //         "</span ></div></div>",
          //       className: "ztgh-div-icon",
          //       iconAnchor: this.djd
          //     });
          //   }
          let baseLayer = L.marker([it.latitude, it.longitude], {
            interactive: true,
            icon: myIcons,
            attributes: it,
          }).addTo(this.basesGroup);
          // baseLayer.on("click", e => {
          //   e;
          //   // this.$store.dispatch(
          //   //   "drawer/setGraphic",
          //   //   e.sourceTarget.options.attributes
          //   // );
          //   // this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
          // });
          baseLayer.on("mouseover", (it) => {
            it.sourceTarget
              .getElement()
              .querySelector(".zhus-div-name")
              .classList.remove("hide");
          });
          baseLayer.on("mouseout", (it) => {
            it.sourceTarget
              .getElement()
              .querySelector(".zhus-div-name")
              .classList.add("hide");
          });
        }
      });
      this.map.addLayer(this.basesGroup);
    },

    //多基地数据加载(比黄星多标注水东、七径两镇) == 蓝星点
    baseLoad2() {
      this.jdArr = [];
      if (this.basesGroup2) {
        this.map.removeLayer(this.basesGroup2);
      }
      this.basesGroup2 = new L.layerGroup();
      this.baseList2.map((it) => {
        if (it.latitude) {
          //   let aPoint = new changeMap(it.latitude, it.longitude);
          //   it.lat = aPoint.lat;
          //   it.lng = aPoint.lng;
          let pointUrl = require("images/map/bluexx.png");
          // let pointUrl = require("images/map/" + it.img + ".png");
          //   let lineUrl = require("images/index/map/line_map.png");
          var myIcons;
          //   if (it.tc_pic === "ico_sf") {
          myIcons = L.divIcon({
            html:
              "<div class='indicator-box sLine2 ico_sf'><div class='ztgh-div-box'><img class='ztgh-div-image " +
              it.tc_pic +
              "' src='" +
              pointUrl +
              "'/><div class='zhu-div-text zhu-div-name zhu-yellow' ><span class='zhus-div-name hide yellow'>" +
              "茂名市荔枝优势产区产业园核心区" +
              "</span></div>" +
              "</div></div>",
            className: "ztgh-div-icon",
            iconAnchor: [16, 8],
          });
          //   }
          //    else {
          //     myIcons = L.divIcon({
          //       html:
          //         "<div class='indicator-box ico_sf'><div style='display:flex'><img src='" +
          //         pointUrl +
          //         "' /></div><div class='ztgh-div-" +
          //         it.tc_leftRight +
          //         "'><img class='Img" +
          //         it.tc_leftRight +
          //         "' src='" +
          //         lineUrl +
          //         "'/><span class='ztgh-div-names'>" +
          //         it.name +
          //         "</span ></div></div>",
          //       className: "ztgh-div-icon",
          //       iconAnchor: this.djd
          //     });
          //   }
          let baseLayer = L.marker([it.latitude, it.longitude], {
            interactive: true,
            icon: myIcons,
            attributes: it,
          }).addTo(this.basesGroup2);
          // baseLayer.on("click", e => {
          //   e;
          //   // this.$store.dispatch(
          //   //   "drawer/setGraphic",
          //   //   e.sourceTarget.options.attributes
          //   // );
          //   // this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
          // });
          baseLayer.on("mouseover", (it) => {
            it.sourceTarget
              .getElement()
              .querySelector(".zhus-div-name")
              .classList.remove("hide");
          });
          baseLayer.on("mouseout", (it) => {
            it.sourceTarget
              .getElement()
              .querySelector(".zhus-div-name")
              .classList.add("hide");
          });
        }
      });
      this.map.addLayer(this.basesGroup2);
    },
    //联动发展带数据加载
    beltLoad() {
      this.ydArr = [];
      if (this.beltGroup) {
        this.map.removeLayer(this.beltGroup);
      }
      this.beltGroup = new L.layerGroup();
      if (this.ydGroup) {
        this.map.removeLayer(this.ydGroup);
      }
      this.ydGroup = new L.layerGroup();
      this.beltObj = {
        area: 80000,
        code: "0599",
        config: [
          [111.00207344931157, 21.40824081949592],
          [111.0299984091313, 21.41846526547389],
          [111.03399984091313, 21.43338434605539],
          [111.04099984091313, 21.45338434605539],
          [111.04899984091313, 21.46738434605539],
          [111.05499984091313, 21.48538434605539],
          [111.06221224325685, 21.509377589354633],
          [111.07021224325685, 21.529377589354633],
          [111.07621224325685, 21.549377589354633],
          [111.08251192587401, 21.569645929394305],
          [111.08319857138182, 21.588571767164977],
          [111.08219857138182, 21.607571767164977],
          [111.08363179892087, 21.626000609173064],
          [111.08563179892087, 21.646000609173064],
          [111.08619857138182, 21.668573276341478],
          [111.08619857138182, 21.688573276341478],
          [111.09219857138182, 21.708573276341478],
          [111.09057186239743, 21.73034283273087],
          [111.09457186239743, 21.75034283273087],
          [111.09557186239743, 21.77034283273087],
          [111.09557186239743, 21.79034283273087],
          [111.09721990145578, 21.813540984445294],
          [111.10021990145578, 21.83852889525281],
          [111.11038079012766, 21.855290262890175],
          [111.09038079012766, 21.875290262890175],
        ],
        desc:
          '<p><span style="font-family: 宋体, SimSun; color: rgb(255, 255, 255); font-size: 12px;">联结包茂高速沿线资源，发挥产业园要素集聚和综合服务优势，成为吸聚高端要素、汇集优秀人才、实现产业高质量发展的中枢发展带。按照休闲农旅融合的方向，以荔枝规模化种植基地为核心要素，整合荔枝贡园、红荔阁、浮山岭、鳄人谷等自然旅游景点，将荔枝绿色高效种植、现代化加工、观光旅游、文化科普等有机串联，形成“一产接二连三”的互动型、融合型发展模式，开发休闲农文旅观光精品旅游线路，打造凸显荔枝优势特色产业集聚、浓郁文化体验、独特民俗风情的休闲农旅融合发展带。</span></p>',
        grade: 3,
        img: "ico_line",
        latitude: "",
        longitude: "",
        name: "荔枝产业集聚与农旅融合发展带",
        tc_color: null,
        tc_id: "0207ee442af14b278dedf9ade66bbc09",
        tc_leftRight: "right",
        tc_name: "一带：荔枝产业集聚与农旅融合发展带",
        tc_pic: "ico_yd.png",
        tc_quote_template: "companyDrawer",
        tc_request_url: "",
        tc_status: 1,
        tc_template: "companyDrawer",
        tc_type: "points",
        type: "points",
      };
      let beltObj = this.beltObj;
      let beltPoints = beltObj.config;
      for (let i = 0, len = beltPoints.length; i < len; i++) {
        let aPoint = new changeMap(beltPoints[i][1], beltPoints[i][0]);
        let iconSize, iconAnchor;
        if (i === 24) {
          iconSize = [40, 40];
          iconAnchor = this.ydwAnchor;
        } else if (i === 0) {
          iconAnchor = this.ydtAnchor;
        } else {
          iconAnchor = this.ydAnchor;
        }
        let ydIcon = L.icon({
          iconUrl: require("images/index/map/jt/" + i + ".png"),
          iconSize: iconSize,
          iconAnchor: iconAnchor,
          popupAnchor: [0, 0],
        });
        let ydData = L.marker([aPoint.lat, aPoint.lng], {
          icon: ydIcon,
          attributes: beltObj,
          interactive: true,
        }).addTo(this.beltGroup);
        if (i === 4) {
          let lineUrl = require("images/index/map/line_map.png");
          let pointUrl = require("images/index/map/point.png");
          let pointIcon = L.divIcon({
            html:
              "<div class='indicator-box'><div style='display:flex'><img style='position:absolute;top:23px;left:18px' src='" +
              pointUrl +
              "' /></div><div class='ztgh-div-" +
              beltObj.tc_leftRight +
              "'><img class='Img" +
              beltObj.tc_leftRight +
              "' src='" +
              lineUrl +
              "'/><span class='ztgh-div-names'>" +
              beltObj.name +
              "</span ></div></div>",
            className: "ztgh-div-icon",
            iconAnchor: [30, 50],
          });
          let ydd = L.marker([aPoint.lat, aPoint.lng], {
            icon: pointIcon,
            attributes: beltObj,
          }).addTo(this.ydGroup);
          ydd.on("click", (e) => {
            sessionStorage.setItem("rightComponent", this.rightPath);
            this.$store.dispatch(
              "drawer/setGraphic",
              e.sourceTarget.options.attributes
            );
            this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
          });
        }
        ydData.on("click", (e) => {
          sessionStorage.setItem("rightComponent", this.rightPath);
          this.$store.dispatch(
            "drawer/setGraphic",
            e.sourceTarget.options.attributes
          );
          this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
        });
      }
      this.map.addLayer(this.beltGroup);
      this.map.addLayer(this.ydGroup);
    },
  },
  destroyed() {
    clearInterval(this.timer);
    // window.map && window.map.remove();
    // window.map = null;
  },
};
</script>

<style lang="stylus" scoped>
.map
    background none !important
    width 100%
    height calc(100% + 105px)
    z-index 9
    // >>>.leaflet-tile-pane
    // display none
    >>>.leaflet-bar
        display none
    >>>.leaflet-bottom
        display none
    .ncDetail
        position absolute
    >>>
        .zhu-div-icon
            color #fff
        .indicator-box
            position relative
        .indicator-box:hover
            z-index 1000
        .zhu-div-text
            position absolute
            height 30px
            display flex
            justify-content center
            align-items center
            width 0.72rem
        .sLine
            transform translate(28%, -67%)
        .zhu-div-box
            display flex
            justify-content center
            align-items center
            flex-wrap wrap
        .zhu-div-image
            width 31px
        .zhu-div-name
            top -30px
            text-align center
        .zhus-div-name.hide
            display none
        .zhus-div-name
            z-index 9
            font-size 0.08rem
            border 1px #fff solid
            border-radius 5px
            padding 2px 10px
            white-space nowrap
        .yellow
            background-color rgba(0, 126, 120, 0.8)
        .nopx-left-btm
            position absolute
            left -120px
            top 17px
        .nopx-left-top
            position absolute
            left: -138px;
            top: -50px;
        .nopx-right-top
            position absolute
            left 14px
            top -19px
        .nopx-right-btm
            position absolute
            left: 14px;
            top: 18px;
        .nopx-right-top-box
            position absolute
            left 144px
            transform: translateY(-50%);
        .nopx-right-btm-box
            position absolute
            left 120px
            bottom -150px
        .nopx-left-top-box
            position absolute
            left -64px
            transform: translateX(-100%);
            top: -178px;
        .nopx-left-btm-box
            position absolute
            left: -105px;
            transform: translateX(-100%);
            bottom: -115px;
        .nopx-pic1
            position absolute
            top -50px

        .ztgh-div-icon
            color #fff
            z-index 970 !important
        .indicator-box
            position relative
        .ztgh-div-image
            position relative
            width 0.1rem
            height 0.1rem
        .ico_sf
            width 0.11rem
            height 0.11rem
        .ztgh-div-text
            position absolute
            width 1.3rem
            height 30px
            display flex
            justify-content center
            align-items center
        .mys-div-right
            top -18px
            left -0.2rem
            text-align center
        .mys-div-left
            text-align center
            top -18px
            right 0.25rem
        .ztgh-div-name
            font-size 0.08rem
            border 1px #fff solid
            border-radius 5px
            background-color rgba(15, 62, 112, 0.8)
            padding 2px 8px
        .ztgh-div-name:hover
            z-index 999
            font-size 0.09rem
        .ztgh-div-names
            font-size 0.08rem
            color #FFF
            position absolute
            width 1.2rem
            text-shadow -1px 0 #FF770C, 0 1px #FF770C, 1px 0 #FF770C, 0 -1px #FF770C
        .ztgh-div-names:hover
            z-index 999
            font-size 0.09rem
        .sLine
            transform translate(-110%, -50%)
        .sLine2
            transform translate(0%, -50%)
        .mys-div-s
            top -25px
            left -0.35rem
            text-align center
        img
            display inline-block
        .ztgh1-div-left
            position absolute
            top -38px
            right 0
            img
                width 100px
                height 38px
            span
                text-align right
                position absolute
                right 100px
                top -11px
        .ztgh1-div-right
            transform rotateY(180deg)
            position absolute
            top -16px
            left 7px
            img
                width 100px
            span
                transform rotateY(-180deg)
                position absolute
                right 100px
                top -11px
        .ztgh-div-left
            position absolute
            top -15px
            right 0
            img
                width 100px
            span
                text-align right
                position absolute
                right 100px
                top -11px
        .ztgh-div-right
            transform rotateY(180deg)
            position absolute
            top 6px
            left 24px
            img
                width 100px
            span
                transform rotateY(-180deg)
                position absolute
                right 100px
                top -11px
        .zxd-div-right
            transform rotateY(180deg)
            position absolute
            top -9px
            left 18px
            img
                width 100px
            span
                transform rotateY(-180deg)
                position absolute
                right 100px
                top -11px
.cyzl-nav-bar
  width 14%

@media (max-width 1280px)
  .mapDiv
    transform scale(0.75)
</style>
